var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wt-background-shield"},[_c('welcome-background-shield',{attrs:{"icon":"welcome-background-shield"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }